export const SETUP_LOGIN = "SETUP_LOGIN";
export const SET_LOGOUT = "SET_LOGOUT";
export const SET_CURRENT_TRAFFIC_LAYER = "SET_CURRENT_TRAFFIC_LAYER";
export const SET_FILTERED_COMPANIES = "SET_FILTERED_COMPANIES"
export const SET_SUPER_ADMIN = "SET_SUPER_ADMIN"
export const SET_COLOR_BLIND = "SET_COLOR_BLIND"
export const SET_UNIT_MEASUREMENT = "SET_UNIT_MEASUREMENT"
export const SET_DISPLAY_MODE = 'SET_DISPLAY_MODE'
export const SET_LOADING = "SET_LOADING";